import { makeStyles } from '@mui/styles';
import { APP_ACTION_COLUMNS } from '../../../utils/constants';
const styles = makeStyles(() => ({
  customTool: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    marginTop: '10px',
  },
  disableImportLabel: {
    fontWeight: 700,
    fontSize: '0.875rem',
    cursor: 'pointer',
    pointerEvents: 'none',
    color: 'rgba(0, 0, 0, 0.26)'
  },
  dialogModal: {
    '& .MuiPaper-root': {
      marginLeft: '10px',
      '& .makeStyles-dialogTitle-37': {
        padding: '16px 12px !important',
      },
      maxWidth: '1320px',
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    }
  },
  disableIcon: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    marginTop: '10px',
    pointerEvents: 'none',
    color: 'rgba(0, 0, 0, 0.26)'
  },
  importLabel: {
    fontWeight: 700,
    fontSize: '0.875rem',
    cursor: 'pointer',
  },
  invalidRow: {
    backgroundColor: '#ffcccc !important'
  },
  checkBoxCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    textAlign: 'center',
    gap: 1,
    flexShrink: 0,
    overflow: 'hidden'
  },
  toolTipStyle: {
    display: 'inline-block'
  },
  submitCell: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontWeight: 600
  },
  submitCellDisable: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'not-allowed',
    fontWeight: 600,
    pointerEvents: 'none'
  },
  disableText: {
    cursor: 'pointer',
    pointerEvents: 'none',
    opacity: 0.5
  },
  rowViewMode: {
    '& .MuiDataGrid-cell': {
      pointerEvents: 'none',
    },
    ...Object.fromEntries(
      APP_ACTION_COLUMNS.map((field) => [
        `& .MuiDataGrid-cell[data-field="${field}"]`,
        {
          pointerEvents: 'auto',
        },
      ])
    ),
  },
}));
export default styles;

export const listItemTextPrimary = {
  fontSize: '1rem',
  fontWeight: 600,
};
